<div class="container" [ngClass]="{
  'locked': (badge.unLocked === false && userPoints < badge.price),
  'unlockable': (badge.unLocked === false && userPoints >= badge.price),
  'selected': badge.selected === true,
  'available': badge.unLocked === true
}" [title]="(badge.unLocked === false && userPoints < badge.price) ? '?' : badge.label">
  <img [src]="userPoints >= badge.price === true ? badge['image-t'] : badge['image-b']" [alt]="badge.label">
  @if (badge.unLocked === false) {
    <div class="locked">
      @if (userPoints >= badge.price) {
        <div class="btn unlock">{{badge.price}}<mat-icon svgIcon="credits"></mat-icon></div>
      }
      @if (userPoints < badge.price) {
        <div class="btn locked-icon">
          <mat-icon svgIcon="lock"></mat-icon>
        </div>
      }
    </div>
  }
</div>
